<div class="esteira-list ui-page-skeleton-modern">
  <div class="container">
    <div class="container-conteudo conteudo d-flex direction-column">
      <!-- <div class="conteudo-page-header page-header d-flex align-center">
        

        <span class="page-header-separator" aria-hidden="true"></span>

        <h1 class="page-header-title">Esteira de Apuração</h1>
      </div> -->

      <div class="conteudo-filters">
        <app-esteira-contract-filter [count]="count" [totalAmount]="totalAmount" [searchText]="searchText"
          (filtersSubmitted)="applyInlineFilters($event)">
        </app-esteira-contract-filter>
      </div>

      <div class="conteudo-list" #contractsRegion>
        <div class="conteudo-list-placeholder" *ngIf="isContractsHeaderPinned"
          [style.height.px]="contractsHeaderHeight">
        </div>

        <div #contractsHeaderFix class="conteudo-list-fix" [class.conteudo-list-fix-pinned]="isContractsHeaderPinned"
          [style.left.px]="isContractsHeaderPinned ? contractsHeaderLeft : null"
          [style.width.px]="isContractsHeaderPinned ? contractsHeaderWidth : null">
          <div class="conteudo-list-toolbar toolbar d-flex align-center">
            <button *ngIf="currentContext === 'invoice'" type="button" class="ui-btn ui-btn--primary"
              [disabled]="!createBatch.showCreateBatchButton" (click)="createBatchForContract()">
              Criar Lote Faturamento
            </button>

            <button *ngIf="currentContext === 'invoice'" type="button" class="ui-btn ui-btn--primary"
              (click)="exportarModal(false)">
              <app-svg-icon src="assets/icons/btnestornar.svg" color="black" width="20px" height="19px">
              </app-svg-icon>
              <span>Estornar</span>
            </button>
          </div>

          <div class="conteudo-list-header header d-flex align-center">
            <app-ordered-header-list [ngClass]="{
              'is-invoice-grid': currentContext === 'invoice',
              'is-transfer-grid': currentContext !== 'invoice'
            }" [headerItems]="headerItems" (orderChangeEvent)="orderChange($event)">
              <div *ngIf="currentContext === 'invoice'" headerFlag class="header-spacer-checkbox"></div>
              <div buttonSpace class="header-spacer-action"></div>
            </app-ordered-header-list>
          </div>
        </div>

        <div #contractsList class="conteudo-contracts contracts d-flex direction-column">
          <app-skeleton *ngIf="isLoading" variant="table-row" [rows]="8" [columns]="headerItems.length"></app-skeleton>

          <ng-container *ngIf="!isLoading">
            <ng-container *ngFor="let contract of contracts; let i = index">
              <app-esteira-contract-card class="contracts-contract" [contract]="contract"
                [currentContext]="currentContext" [linha]="i+1"
                [checkedContracts]="checkedContracts"></app-esteira-contract-card>
            </ng-container>

            <div *ngIf="contracts.length === 0" class="contracts-empty empty">
              <span class="empty-message"> Sem contratos disponíveis </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="count > contracts.length">
    <app-scroll-pagination [count]="count" [resetKey]="paginationResetKey"
      (viewMoreTrigger)="handlePagination($event)"></app-scroll-pagination>
  </ng-container>
</div>